export const mapProductOption = ({ id, name }) => ({ value: id, label: name })
